export default "__VITE_ASSET__ba55c9dd__"